export default function Analytics() {
  return <div>Analytics</div>;
}
